// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GzFct","title":"styles_title__1zKey"};